import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { configurationComplete } from '@state';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const descProps = ['roomName', 'baseUnit'];
const measurementProps = ['width', 'length', 'height'];
const keyPairs = {
  roomName: 'Room Name',
  baseUnit: '_userUnit',
  width: 'Width',
  length: 'Length',
  height: 'Height',
};

const propertiesToURL = (data) => {
  let outArray = [];
  let dataKeys = Object.keys(data);
  let filteredDescProps = dataKeys.filter((value) => descProps.includes(value));
  filteredDescProps.forEach((key) => {
    if (data.hasOwnProperty.call(data, key) && Boolean(data[key])) {
      outArray.push(`${keyPairs[key]}=${encodeURIComponent(data[key])}`);
    }
  });
  let filteredMeasureProps = dataKeys.filter((value) => measurementProps.includes(value));
  filteredMeasureProps.forEach((key) => {
    if (data.hasOwnProperty.call(data, key) && Boolean(data[key])) {
      outArray.push(
        `${keyPairs[key]}=${data.baseUnit === 'metric' ? encodeURIComponent(data[key]) : encodeURIComponent(data[key] * 25.4)}`
      );
    }
  });
  return outArray.join('&');
};

const ShareableLink = () => {
  const [copied, setCopied] = useState(false);
  const { isComplete, data } = useRecoilValue(configurationComplete);

  const url = `${window.location.origin}${window.location.pathname}/?${propertiesToURL(data)}`;

  return (
    <div>
      <CopyToClipboard text={url} onCopy={() => setCopied(true)}>
        <button type="button" className="button" data-style="darkgray text" disabled={!Boolean(isComplete)}>
          {Boolean(isComplete) ? <>{copied ? 'Link saved to your clipboard!' : 'Share Configuration'}</> : <div>Add Label to Share</div>}
        </button>
      </CopyToClipboard>
    </div>
  );
};

export default ShareableLink;
